<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Service
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/service/sub-visual-service.jpg"></v-img>
            <sub-tab page="고객센터" :tabActive="3"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: question-->
        <section class="sub-section sub-section--question">
            <v-container class="font-pretendard">
                <faq-list />
            </v-container>
        </section>
        <!-- E: question-->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
import FaqList from "@/components/client/center/faqs/faq-list.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        FaqList,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
